import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { config } from '../config';

export default function Gallery() {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await fetch(`${config.SERVER_BASE_URL}/api/photos/gallery`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        if (res.ok) {
          const data = await res.json();
          setPhotos(data);
        }
      } catch (err) {
        console.error('Failed to fetch gallery', err);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, []);

  const handleEdit = (url) => {
    navigate('/studio', { state: { imageSrc: url } });
  };

  return (
    <div className="h-full flex flex-col bg-slate-50 overflow-y-auto">
      <header className="px-8 py-6 border-b border-slate-200 bg-white">
        <h1 className="text-2xl font-bold text-slate-800">My Gallery</h1>
        <p className="text-slate-500 mt-1">View your previously uploaded and processed photos</p>
      </header>
      <div className="p-8">
        {loading ? (
          <div className="flex justify-center py-10">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        ) : photos.length === 0 ? (
          <div className="text-center py-10 text-slate-500">
            <p>You haven't uploaded any photos yet.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {photos.map(photo => (
              <div key={photo._id} className="group relative aspect-square bg-slate-100 rounded-2xl border border-slate-200 overflow-hidden flex items-center justify-center hover:border-blue-300 transition-colors cursor-pointer shadow-sm">
                <img
                  src={photo.url}
                  alt="Gallery item"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-2 right-2 px-2 py-1 bg-black/60 text-white text-[10px] rounded uppercase font-bold tracking-wider">
                  {photo.isBgRemoved ? 'No BG' : 'Raw'}
                </div>
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                  <button
                    onClick={() => handleEdit(photo.url)}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-lg transition-colors"
                  >
                    Edit in Studio
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
